import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
} from "@mui/material";

interface HasIdField {
  id: any;
}

interface Props<T extends HasIdField> {
  headers: { key: keyof T; value: string | number }[];
  data: T[];
  getCustomComponentForField?: (
    field: keyof T,
    idx: number
  ) => React.ReactNode | null;
  onRowClick?: (idx: number) => void;
}

const BasicTable = <T extends HasIdField>({
  headers,
  data,
  getCustomComponentForField,
  onRowClick,
}: Props<T>) => {
  const getOnClick = (idx: number) => {
    return () => onRowClick && onRowClick(idx);
  };
  const getCell = (datum: T, field: keyof T, idx: number) => {
    if (getCustomComponentForField && getCustomComponentForField(field, idx)) {
      return <TableCell>{getCustomComponentForField(field, idx)}</TableCell>;
    }
    return <TableCell>{`${datum[field]}`}</TableCell>;
  };
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((h) => (
              <TableCell sx={{ fontWeight: 700, fontSize: 14 }}>
                {h.value}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((d: T, idx) => (
            <TableRow
              className={`${onRowClick !== undefined && "pointer-hover"}`}
              onClick={getOnClick(idx)}
              key={d.id}
            >
              {headers.map((h) => getCell(d, h.key, idx))}
            </TableRow>
          ))}
          {data.length === 0 && (
            <TableRow>
              <TableCell>No data</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BasicTable;
